<!--<app-header>
  <jbm-view-title [caption]="'menu.dashboard'|translate" [iconClassname]="'tachometer-alt'"></jbm-view-title>
  <div class="toolbar float-end">
    <jbm-help-button [helpTopicID]="0"></jbm-help-button>
  </div>
</app-header>-->

<section class="module dashboard padding padding-top">
  <div class="row">
    <div class="col-6">
      <dashboard-operational></dashboard-operational>
    </div>
    <div class="col-6">
      <dashboard-financial></dashboard-financial>
    </div>
  </div>

<!--   <jbm-dashboard
    #dashboard
    [layout]="dashboardLayout"
    [widgetVisibility]="widgetVisibility"
    [userRights]="userRights"
    (onSaveLayout)="saveLayout($event)">
    </jbm-dashboard>-->
</section>
